import Header from '../components/Header';
import Hero from '../components/Hero';
import WhyUs from '../components/WhyUs';
import Gallery from '../components/Gallery';
import Products from '../components/Products';
import Services from '../components/Services';
import Parts from '../components/Parts';
import Contact from '../components/Contact';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const HomePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <WhyUs />
      <Gallery />
      <Products />
      <Services />
      <Parts />
      <Contact />
      <Clients />
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default HomePage;
